import { PopoverPlacementType } from "../popover/interface";

export interface GuidedTourData {
    /** automatically start the tour */
    autoStart?: boolean;
    /** label for the autoStart switch */
    autoStartLabel?: string;
    /** optional intro step shown at the beginning of the tour */
    intro?: GuidedTourStep;
    /** optional outro step shown at the end of the tour */
    outro?: GuidedTourStep;
    /** optional custom z-index for the overlay */
    overlayZIndex?: string;
    /** array with guided tour steps */
    steps: GuidedTourStep[];
    /** optional label for the 'finish tour' button of the last step */
    finishTourButtonLabel?: string;
}

export interface GuidedTourStep {
    /** optional classNames for the back button */
    backButtonClassNames?: string;
    /** optional label for the back button */
    backButtonLabel?: string;
    /** description text that is displayed in the popover */
    body: string;
    /** visual effect applied to the focus area */
    focusFx?: "glow" | "shadow";
    /** optional classNames for the next step button */
    nextButtonClassNames?: string;
    /** optional label for the next step button */
    nextButtonLabel?: string;
    /** optional placement of the tooltip relative to the target element */
    placement?: PopoverPlacementType;
    /** the css selector used to find the element in the DOM tree that should be highlighted */
    target?: string;
    /** distance of highlight area / popover panel from the target element */
    targetOffset?: number;
    /** title that is displayed in the popover */
    title?: string;
    /** hide the steps counter */
    hideStepsCount?: boolean;
    /** hide the progress bar */
    hideProgressBar?: boolean;
}
